import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { SendPackageStateEnumProvider } from "src/Warehouse/SendCartable/sendCartableForm/sendCartableForm-viewModel";
import { ServerSideDataLoader } from "uicomponents";
import { ReceiveCartableListViewModel, SendPackage } from "./receiveCartableList-viewModel"

export class ReceiveCartableListView extends View<ReceiveCartableListViewModel>{
    GetViewUniqueId(): string {
        return "V-D75CEB17-D32B-41B6-B2FC-DA86D485E247"
    }
    loadHtml(): string {
        let element = require('./receiveCartableList.html').default;
        let style = require('./receiveCartableList.less');
        return element;
    }
    constructor() {
       super();
    }
    public set sendPackages(v: ObservableArray<SendPackage>) { this._sendPackages = v; } public get sendPackages(): ObservableArray<SendPackage> { return this._sendPackages;} private _sendPackages: ObservableArray<SendPackage>;
    public set sendPackageStateEnumProvider(v: SendPackageStateEnumProvider) { this._sendPackageStateEnumProvider = v; } public get sendPackageStateEnumProvider(): SendPackageStateEnumProvider { return this._sendPackageStateEnumProvider;} private _sendPackageStateEnumProvider: SendPackageStateEnumProvider;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

}
